//#region src/components/dropdown/menu-motion.ts
var e = (e) => e.type.startsWith("pointer") || e.type.startsWith("mouse") || e.type === "click" && "detail" in e && Number(e.detail) > 0;
//#endregion
export { e as isPointerMenuEvent };
